import { SvgIcon } from "@material-ui/core";

export const BinderPresentationIcon = ({
  className,
  fontSize = 80,
}: {
  className?: string;
  fontSize?: number;
}) => {
  return (
    <SvgIcon
      className={className}
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      style={{ fontSize, fill: "none" }}
    >
      <path
        d="M76.6667 60.7575C76.6667 59.6077 76.1996 58.5298 75.3732 57.7035L64.4864 46.8166C63.5162 45.8465 61.9713 45.7387 60.9293 46.637C59.8154 47.6071 59.7795 49.3317 60.8215 50.3378L59.0609 48.5772C58.0908 47.6071 56.5458 47.4993 55.5038 48.3976C54.39 49.3677 54.3541 51.0923 55.396 52.0984L53.4558 50.1581C52.5935 49.2958 51.2282 49.1162 50.2221 49.7629V11.0303C50.2221 9.23375 48.749 7.76062 46.9525 7.76062H8.75877C6.96227 7.76062 5.48914 9.23375 5.48914 11.0303V61.1527C5.48914 62.9493 6.96227 64.4224 8.75877 64.4224H46.9884C47.9585 64.4224 48.4615 64.3146 49.0723 63.6679L49.3598 60.4701L50.4018 61.512L55.5398 66.6501C55.7913 66.9016 55.935 67.2249 55.8631 67.5842C55.7913 68.0873 55.432 68.4466 54.929 68.5184L43.9703 70.2431C42.6049 70.4227 41.6348 71.6084 41.6348 72.9737C41.6348 73.5486 42.1378 74.0157 42.7127 74.0157H63.3366C65.9595 74.0157 68.4387 72.9737 70.307 71.1413L73.7563 67.692C75.6606 65.8596 76.6667 63.3804 76.6667 60.7575ZM49.3598 60.506L50.0784 61.2246L49.3598 60.506Z"
        fill="#F1CAA4"
      />
      <path
        d="M35.7064 50.697C33.8021 48.7928 33.6943 45.7746 35.419 43.7985C36.3532 42.7565 37.6107 42.1457 38.9761 42.1098C39.0479 42.1098 39.1198 42.1098 39.1916 42.1098C40.4851 42.1098 41.7427 42.6487 42.6769 43.5829L43.8985 44.8045C44.5812 45.4872 45.7668 45.0201 45.7668 44.05V16.0245C45.7668 14.8388 44.7967 13.8328 43.5751 13.8328H12.1722C10.9865 13.8328 9.98047 14.8029 9.98047 16.0245V53.3918C9.98047 54.5775 10.9506 55.5835 12.1722 55.5835H37.9341C38.9042 55.5835 39.3713 54.3978 38.6886 53.7152L35.7064 50.697Z"
        fill="#E8EFEA"
      />
      <path
        d="M26.2567 60.3264C27.0902 60.3264 27.7658 59.6507 27.7658 58.8173C27.7658 57.9839 27.0902 57.3082 26.2567 57.3082C25.4233 57.3082 24.7477 57.9839 24.7477 58.8173C24.7477 59.6507 25.4233 60.3264 26.2567 60.3264Z"
        fill="#E8EFEA"
      />
      <path
        d="M25.7178 59.2484C26.2536 59.2484 26.6879 58.8141 26.6879 58.2783C26.6879 57.7426 26.2536 57.3082 25.7178 57.3082C25.182 57.3082 24.7477 57.7426 24.7477 58.2783C24.7477 58.8141 25.182 59.2484 25.7178 59.2484Z"
        stroke="#226937"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.8867 59.428L37.4311 48.9724C36.461 48.0023 36.3532 46.4573 37.2514 45.4153C38.2215 44.3015 39.9462 44.2655 40.9522 45.3075L47.6352 51.9905C46.5932 50.9485 46.6292 49.2598 47.743 48.2897C48.7491 47.3914 50.33 47.4992 51.3001 48.4693L53.2403 50.4096C52.1983 49.3676 52.2343 47.6789 53.3481 46.7088C54.3541 45.8105 55.9351 45.9183 56.9052 46.8884L58.6658 48.649C57.6238 47.607 57.6597 45.9183 58.7736 44.9482C59.7796 44.0499 61.3605 44.1577 62.3306 45.1279L73.2175 56.0147C74.0438 56.8411 74.5109 57.919 74.5109 59.0687C74.5109 59.0687 74.5109 59.0687 74.5109 59.1047C74.5109 61.7276 73.5049 64.2067 71.6365 66.0392L68.1872 69.4885C66.3548 71.3209 63.8397 72.3629 61.2168 72.3629H40.5929C40.018 72.3629 39.515 71.8958 39.515 71.3209C39.4791 69.9556 40.4851 68.8058 41.8505 68.5902L52.8092 66.8656C53.2762 66.7937 53.6715 66.3985 53.7433 65.9314C53.7793 65.5721 53.6355 65.2487 53.42 64.9972L48.282 59.8592L47.24 58.8172L40.1618 51.739"
        stroke="#EA7200"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0764 30.3965V36.6124"
        stroke="#226937"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2383 30.3965V36.6124"
        stroke="#226937"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2383 33.4865H14.0764"
        stroke="#226937"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.7839 36.6124V30.3965"
        stroke="#226937"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.9458 30.3965L30.7839 33.4865L33.9458 36.6124"
        stroke="#226937"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.2147 36.6124V30.3965L28.3766 36.6124V30.3965"
        stroke="#226937"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6456 30.3965V35.0315C19.6456 35.8938 20.3642 36.6124 21.2266 36.6124C22.0889 36.6124 22.8075 35.8938 22.8075 35.0315V30.3965"
        stroke="#226937"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.353 36.7202H37.934C38.7963 36.7202 39.5149 36.0016 39.5149 35.1393C39.5149 34.2769 38.7963 33.5583 37.934 33.5583C37.0716 33.5583 36.353 32.8397 36.353 31.9774C36.353 31.1151 37.0716 30.3965 37.934 30.3965H38.9759"
        stroke="#226937"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.0663 45.3794V9.26964C48.0663 7.47313 46.5932 6 44.7967 6H6.60301C4.80651 6 3.33337 7.47313 3.33337 9.26964V59.3921C3.33337 61.1886 4.80651 62.6618 6.60301 62.6618H44.8326C45.8027 62.6618 46.3058 62.554 46.9166 61.9072"
        stroke="#EA7200"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.8621 53.3918H8.90249C8.29168 53.3918 7.82458 52.8888 7.82458 52.3139V12.7908C7.82458 12.18 8.32761 11.7129 8.90249 11.7129H42.5331C43.1439 11.7129 43.611 12.2159 43.611 12.7908V44.5171"
        stroke="#EA7200"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
